import './index.scss';

import { ApolloClient, ApolloProvider, HttpLink, gql } from '@apollo/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { cache } from './cache';

import { AuthProvider } from 'react-oidc-context';
import BodyClassName from 'react-body-classname';
import { GlobalModal } from "./hooks/globalModal";
import { MusicEngineProvider } from 'audio/MusicEngineContext';
import Pages from './pages';
import React from 'react';
import ReactDOM from 'react-dom';
import { ScaleExtensions } from 'lib/tonalExtensions';
import SnackbarProvider from 'react-simple-snackbar';
import { userManager } from './auth/userManager';
import { navigate } from '@reach/router';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';

//import 'bulma/css/bulma.min.css';

ScaleExtensions();

const typeDefs = gql`
  extend type Query {
    theNumber: Int!
  }
`;

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const authLink = setContext(async (_, { headers }) => {
  const user = await userManager.getUser();
  return {
    headers: {
      ...headers,
      ...(user?.access_token ? { authorization: `Bearer ${user.access_token}` } : {}),
    },
  };
});

const GET_ERROR = gql`
  query GetError {
    error @client
    {
      message @client
    }
  }
`;

const getErrorLink = ({ getApolloClient }) => {
  return (
    onError(({ graphQLErrors, networkError, operation }) => {
      const { cache } = operation.getContext();
      if (graphQLErrors)
        graphQLErrors.map(({ message, path, extensions }) => {
          console.error(`[GraphQL error]: Message: ${message}, Operation: ${operation.operationName}, Path: ${path}`);
          switch (extensions.code) {
            case "UNAUTHENTICATED":
              // Don't force-clear the session here — a single failed request
              // (clock skew, a transient network blip) shouldn't kill an
              // otherwise-valid login. automaticSilentRenew handles real
              // expiry; react-oidc-context flips isAuthenticated on its own
              // once the token is actually expired.
              /* cache.writeQuery({
                query: GET_ERROR,
                data: {
                  error: {
                    message: "!"+graphQLErrors[0].message,
                  },
                },
              }); */
              break;
            case "BAD_USER_INPUT":
            default:
              break;
          }
        }
        );
      if (networkError) {
        console.error(`[Network error]: ${networkError}`);
        //navigate("/networkerror");
      }
    })
  )
}

const client = new ApolloClient({
  cache,
  //uri: 'http://localhost:4000/graphql',
  link: getErrorLink({ getApolloClient }).concat(authLink).concat(httpLink),
  typeDefs,
})

function getApolloClient() {
  return client;
}

const onSigninCallback = (user) => {
  window.history.replaceState({}, document.title, window.location.pathname);
  if (user?.state?.returnTo) {
    navigate(user.state.returnTo);
  }
};

console.log("Render App")
console.log("Env: "+process.env.REACT_APP_API_URL)

ReactDOM.render(
  <AuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
    <MusicEngineProvider>
      <ApolloProvider client={client}>
        <HelmetProvider>
          <Helmet>
            <title>TuneIn</title>
            <meta name="description" content="Music theory app"></meta>
          </Helmet>
          <BodyClassName className="has-navbar-fixed-top">
            <SnackbarProvider>
              <GlobalModal>
                <Pages />
              </GlobalModal>
            </SnackbarProvider>
          </BodyClassName>
        </HelmetProvider>
      </ApolloProvider>
    </MusicEngineProvider>
  </AuthProvider>,
  document.getElementById('root'),
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
